export const party_sort = [
  'SP',
  'SVP',
  'GLP',
  'GPS',
  'FDP',
  'LPS',
  'Mitte',
  'CVP',
  'BDP',
  'Lega',
  'EVP',
  'andere',
]
export const party_list = [
  'Schweiz',
  'SP',
  'GPS',
  'EVP',
  'GLP',
  'BDP',
  'Mitte',
  'andere',
  'CVP',
  'FDP',
  'LPS',
  'Lega',
  'SVP',
]

export const party_colors: { [key: string]: string } = {
  // links: '#D3343F',
  SP: '#F0554D',
  GPS: '#84B547',
  EVP: '#DEAA28',
  GLP: '#C4C43D',
  BDP: '#E6C820',
  andere: '#202346',
  CVP: '#964800',
  FDP: '#3872B5',
  Lega: '#9070D4',
  SVP: '#4B8A3E',
  neutral: '#7d7d7d',
  Mitte: '#E78D38',
  LPS: '#618DEA',
  // rechts: '#378EBD',
}
export const party_colors_dm: { [key: string]: string } = {
  // links: '#000000',
  SP: '#F0554D',
  GPS: '#84B547',
  EVP: '#DEAA28',
  GLP: '#C4C43D',
  BDP: '#E6C820',
  andere: '#202346',
  CVP: '#F1BE8D',
  FDP: '#3B79BF',
  Lega: '#9070D4',
  SVP: '#4B8A3E',
  Mitte: '#E78D38',
  LPS: '#618DEA',
  // rechts: '#785d24',
}

export const party_colors_text: { [key: string]: string } = {
  // links: '#fff',
  SP: '#fff',
  GPS: 'var(--brandblue-main)',
  EVP: 'var(--brandblue-main)',
  GLP: 'var(--brandblue-main)',
  BDP: 'var(--brandblue-main)',
  andere: 'var(--brandblue-main)',
  CVP: '#fff',
  FDP: '#fff',
  Lega: '#fff',
  SVP: '#fff',
  Mitte: 'var(--brandblue-main)',
  LPS: '#fff',
  // rechts: '#fff',
}
export const party_colors_text_dm: { [key: string]: string } = {
  // links: '#fff',
  SP: '#fff',
  GPS: '#fff',
  EVP: 'var(--brandblue-main)',
  GLP: '#fff',
  BDP: '#fff',
  andere: '#fff',
  CVP: '#fff',
  FDP: '#fff',
  Lega: 'var(--brandblue-main)',
  SVP: '#fff',
  Mitte: '#fff',
  LPS: '#fff',

  // rechts: '#fff',
}

export const party_names: { [key: string]: string } = {
  links: 'Kleine Linksp.',
  SP: 'SP',
  GPS: 'GPS',
  EVP: 'EVP',
  GLP: 'GLP',
  BDP: 'BDP',
  andere: 'Andere',
  CVP: 'CVP',
  FDP: 'FDP',
  Lega: 'Lega',
  SVP: 'SVP',
  rechts: 'Kleine Rechtsp.',
  Schweiz: 'Alle Parteien',
  Mitte: 'Mitte',
}
export const party_names_long: { [key: string]: string } = {
  links: 'Kleine Linksparteien',
  SP: 'SP',
  GPS: 'GPS',
  EVP: 'EVP',
  GLP: 'GLP',
  BDP: 'BDP',
  andere: 'Andere',
  CVP: 'CVP',
  FDP: 'FDP',
  Lega: 'Lega',
  SVP: 'SVP',
  rechts: 'Kleine Rechtsparteien',
  Schweiz: 'Alle Parteien',
  Mitte: 'Mitte',
}
